import { __assign } from "tslib";
import React from 'react';
import { Button, Tooltip } from 'antd';
import { uuid } from '@ekuaibao/helpers';
import './ActionBar.less';
export default function ActionBar(props) {
    var actions = props.actions, isShow = props.isShow;
    return (React.createElement("div", { className: "action-btn-wrapper" }, isShow && (actions === null || actions === void 0 ? void 0 : actions.map(function (v, idx) {
        var key = v.text + "_" + idx;
        var component = !!(v === null || v === void 0 ? void 0 : v.tip) ? (React.createElement(ButtonWithTips, __assign({ key: key }, v))) : (React.createElement(ButtonComponent, __assign({ key: key }, v)));
        if (v === null || v === void 0 ? void 0 : v.wrapper) {
            return ((v === null || v === void 0 ? void 0 : v.isShow) && (v === null || v === void 0 ? void 0 : v.wrapper({
                key: key,
                component: component,
            })));
        }
        else {
            return (v === null || v === void 0 ? void 0 : v.isShow) && component;
        }
    }))));
}
var ButtonWithTips = function (props) {
    return (React.createElement(Tooltip, { title: props === null || props === void 0 ? void 0 : props.tip },
        React.createElement("div", null,
            React.createElement(ButtonComponent, __assign({}, props)))));
};
var ButtonComponent = function (v) {
    var _a;
    var btnType = (v === null || v === void 0 ? void 0 : v.isDisabled) ? 'default' : (_a = v === null || v === void 0 ? void 0 : v.type) !== null && _a !== void 0 ? _a : 'primary';
    var onClick = function () {
        var _a;
        if (v === null || v === void 0 ? void 0 : v.isDisabled)
            return;
        (_a = v === null || v === void 0 ? void 0 : v.onClick) === null || _a === void 0 ? void 0 : _a.call(v);
    };
    return (React.createElement(Button, { key: uuid(10) + ("" + (v === null || v === void 0 ? void 0 : v.text)), className: "btn " + ((v === null || v === void 0 ? void 0 : v.isDisabled) && 'disabled'), type: btnType, onClick: onClick }, v === null || v === void 0 ? void 0 : v.text));
};
